<template>
  <el-card class="margin-top-2">
    <template slot="header">
      <span>数据查询列表</span>
    </template>
    <el-table ref="dataTable" :auto-load="false" :data="table.data" highlight-current-row stripe border height="250">

      <el-table-column prop="rc_order" label="执行顺序" show-overflow-tooltip></el-table-column>
      <el-table-column prop="cm_name" label="组件名" show-overflow-tooltip></el-table-column>
      <el-table-column prop="cm_class" label="组件实现类" show-overflow-tooltip></el-table-column>
      <el-table-column prop="cm_conf" label="组件配置" show-overflow-tooltip></el-table-column>
    </el-table>
  </el-card>
</template>

<script>
export default {
  props: {
    datsp: {}
  },
  data() {
    return {
      table: {
        data: []
      }
    };
  },
  // 当前组件显示到页面之后立即执行，（挂载到页面）
  mounted() {
    this.loadInfo();
  },
  methods: {
    loadInfo() {
      this.table.data = this.datsp;
    }
    /*  queryRcCom(){
      this.$refs.dataTable.load();
    },
    //表格数据加载
    dataTableLoad(params, resolve){
      this.table.data = this.datrc
    }, */
  }
};
</script>

<style>
</style>
